import { memo } from "react";
import { Pressable } from "react-native";
import { Text } from "react-native-paper";
import { themeRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import ProfileIcon from "../ChatUI/ProfileIcon";
import SheetHandle from "../SheetHandle";

type Props = {
	handleExpandCollapse: () => void;
	handleInteractionStart?: () => void;
	aiAssistant?: {
		icon: string;
		alias: string;
	};
	headerIcon?: React.ReactNode;
	headerLabel?: string;
};

const PostAnswerSheetHandle = ({
	handleExpandCollapse,
	handleInteractionStart,
	aiAssistant,
	headerIcon,
	headerLabel,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const cardRadius = theme.roundness * themeRoundnessMultiplier;
	const hasHeaderRow = Boolean(headerLabel || aiAssistant);

	if (!hasHeaderRow) {
		return <SheetHandle onPress={handleExpandCollapse} />;
	}

	return (
		<Pressable
			onPress={handleExpandCollapse}
			onPressIn={handleInteractionStart}
			disabled={!handleExpandCollapse}
		>
			<Box
				width="100%"
				backgroundColor={theme.palette.success.info}
				style={{
					borderTopLeftRadius: isMobile ? 24 : cardRadius,
					borderTopRightRadius: isMobile ? 24 : cardRadius,
				}}
			>
				{isMobile && (
					<SheetHandle
						onPress={handleExpandCollapse}
						backgroundColor={theme.colors.border}
					/>
				)}
				<Box
					flexDirection="row"
					alignItems="center"
					justifyContent="space-between"
					paddingHorizontal={16}
					paddingBottom={isMobile ? 20 : 16}
					paddingTop={isMobile ? 0 : 16}
				>
					<Box flexDirection="row" alignItems="center" gap={8}>
						{headerIcon}
						<Text variant="titleMedium">{headerLabel}</Text>
					</Box>
					{aiAssistant ? (
						<Box flexDirection="row" alignItems="center" gap={8}>
							<ProfileIcon uri={aiAssistant.icon} />
							<Text variant="titleMedium">{aiAssistant.alias}</Text>
						</Box>
					) : null}
				</Box>
			</Box>
		</Pressable>
	);
};

export default memo(PostAnswerSheetHandle);
